import { IStat } from "../../interfaces/Toast";
import { SublabelText } from "../shared/Label/style";
import Transition from "../shared/Transition";
import { StatContainer, StatData } from "./style";

interface IStatProps extends IStat {}

function Stat({ label, value, valueColor }: IStatProps) {
  return (
    <StatContainer>
      <SublabelText>{label}</SublabelText>
      <Transition key={String(label)}>
        <StatData color={valueColor}>{value}</StatData>
      </Transition>
    </StatContainer>
  );
}

export default Stat;
